import React from "react";
import style from "./contactform.module.scss";
import { withRouter } from "react-router-dom";


const ThankYouPage = ({history}) => {

    const handleContinue =()=>{
        history.push({
            pathname: "/",
        })
    }


  return (
    <div className={style.thank_outer}>
        <div className={style.container_thank}>
      <div className={style.thank_sec}>
        <h1 className={style.heading_thank}>Thank You!</h1>
      </div>
      <div className={style.thank_pera}>
      <p className={style.paragraph_thank}>
        you made it… your decision to get this report just gave you an unfair
        advantage. Thanks for trusting us with your info. Your free report is on the
        way, we will get that over to you shortly Have a great day!
      </p>
      <button onClick={()=>handleContinue()} className={style.continue_thank}>Continue</button>
      </div>
    </div>
    </div>
  );
};


export default withRouter(ThankYouPage);
